<template>

    <div class="content-wrap page-bierkul-tour">

        <header class="hero--sm">
            <h1 class="hero-heading">
                <small>Ein Fest ist ein Fest.</small>
                Oder ein Zissel!
            </h1>
        </header>

        <section class="section--interlude">

            <div class="container">

                <div class="row">

                    <div class="col sm-8">

                        <h2>Die Brauereibesichtigungen bei Zissel</h2>

                        <p>erfreuen sich in den letzten Jahren immer größerer Beliebtheit.</p>

                        <p>Immer freitags und samstags können Sie hinter<br>
                            die Kulissen der Zissel-Braukunst blicken.</p>
                    </div>

                </div>
                
            </div>


        </section>


        <section class="section--light">

            <div class="container">
                <div class="row">

                    <div class="col sm-6">
                        <p>
                            Wir laden Sie ein, in unserer Privatbrauerei die Herstellung unserer Biere kennenzulernen.
                            Dabei werden Sie sowohl mit unseren Rohstoffen als auch mit dem modernen Stand der
                            Brautechnik vertraut gemacht. Selbstverständlich können Sie während des Rundgangs unsere
                            verschiedenen Biere verkosten. Ein bieriges Erlebnis erwartet Sie!
                        </p>

                        <div class="infobox">

                            <h3>Führungen nach telefonischer Anmeldung:</h3>
                            <ul>
                                <li>freitags 16.00 Uhr </li>
                                <li>samstags 16.00 Uhr</li>
                                <li>Kosten für Führung inklusive Bier und Brauervesper: 15 Euro pro Teilnehmer.</li>
                                <li>Führungen mit unserem Braumeister und spezielle Arrangements sind ebenfalls möglich.</li>
                            </ul>
                            <p>
                                Buchungen <a href="mailto:#0">hier per E-Mail</a> oder bei<br>
                                <b>Peter Gröger, Telefon (0 92 14) 13 24 53</b>
                            </p>

                        </div>

                    </div>

                    <div class="col sm-6">
                        <img src="assets/img/einkehren-slider-2.jpg" alt="Brauereiführung">
                    </div>

                </div>
            </div>

        </section>


        <app-footer></app-footer>

    </div>


</template>

<script>
import setParallax from '../lib/setParallax'
import appFooter from './partials/footer.vue'

export default {
    components: { appFooter },

    mounted() {

        this.$nextTick(() => {

            setParallax({
                el: '[class^="hero"]',
                attr: 'background-position-y',
                speed: 10
            })

        })

    },
}

</script>



// WEBPACK FOOTER //
// bierkul-tour.vue?f38f479c